import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
import * as moment from 'moment';
import 'moment/locale/pt-br';

// Service
import { ParameterService } from '../../service/parameters/parameters.service';

@Component({
	selector: 'app-parameters',
	templateUrl: './parameters.component.html',
	providers: [
		ParameterService,
		HttpModule
	]
})

export class ParametersComponent implements OnInit {

	private token;
	public parameters: any[] = [];
	public permissoes: any[] = [];
	parametersGroups: any[] = [];
	parametersTypes: string[] = [];

	constructor(fb: FormBuilder, private parameterService: ParameterService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		this.getParameters(false);
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	getParameters(tipo) {
		this.parameterService.getParameters(this.token).subscribe(result => {
			if (result.Success) {
				this.parameters = result.Result;
				var groups = [];

				// Agrupa o resultado com base nos grupos
				this.parameters.forEach(function (value, index) {
					var exists = false;
					for (var i = 0; i < groups.length; i++) {
						if (value.Grupo == groups[i].Grupo) {
							exists = true;
						}
					}
					if (!exists) {
						groups.push(value);
					}
				});

				this.parametersGroups = groups;

				if (tipo) {
					setTimeout(function () {
						$(document).find(".card-header a." + tipo).trigger("click");
					}, 100);
				}

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	insertParameter(grupo, tipo, valor, id) {
		var data = [];

		// if (tipo == "anexo") {
		// 	valor = "*." + valor;
		// }

		if (tipo == "trabalho") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "entrada", Valor: $(".entry").val(), Ativo: true, ID: $(".entry").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "almocoinicio", Valor: $(".lunch").val(), Ativo: true, ID: $(".lunch").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "almocofim", Valor: $(".lunchback").val(), Ativo: true, ID: $(".lunchback").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "saida", Valor: $(".exit").val(), Ativo: true, ID: $(".exit").attr("id") });
		} else if (tipo == "email") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "Host", Valor: $(".host").val(), Ativo: true, ID: $(".host").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "CredentialName", Valor: $(".credentialName").val(), Ativo: true, ID: $(".credentialName").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "CredentialPassword", Valor: $(".credentialPassword").val(), Ativo: true, ID: $(".credentialPassword").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "Port", Valor: $(".port").val(), Ativo: true, ID: $(".port").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "From", Valor: $(".from").val(), Ativo: true, ID: $(".from").attr("id") });
		} else if (tipo == "restricao") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "diasvcto", Valor: $(".diasvcto").val(), Ativo: true, ID: $(".diasvcto").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "plcnormal", Valor: $(".plcnormal").val(), Ativo: true, ID: $(".plcnormal").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "vlmaxnormal", Valor: $(".vlmaxnormal").val(), Ativo: true, ID: $(".vlmaxnormal").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "plcpremium", Valor: $(".plcpremium").val(), Ativo: true, ID: $(".plcpremium").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "vlmaxpremium", Valor: $(".vlmaxpremium").val(), Ativo: true, ID: $(".vlmaxpremium").attr("id") });
		} else if (tipo == "cobranca") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "ctipos", Valor: $(".ctipos").val(), Ativo: true, ID: $(".ctipos").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "cdias", Valor: $(".cdias").val(), Ativo: true, ID: $(".cdias").attr("id") });
		} else if (tipo == "alcada") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "historicoPrazoAlcada", Valor: $(".palcada").val(), Ativo: true, ID: $(".palcada").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "tituloAbertoAlcada", Valor: $(".talcada").val(), Ativo: true, ID: $(".talcada").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "historicoPesoAlcada", Valor: $(".halcada").val(), Ativo: true, ID: $(".halcada").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "conceitoAlcada", Valor: $(".calcada").val(), Ativo: true, ID: $(".calcada").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "vlmaxalcada", Valor: $(".valcada").val(), Ativo: true, ID: $(".valcada").attr("id") });
		} else if (tipo == "rfcsap") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "gruposClienteExportacao", Valor: $(".irfcsap").val(), Ativo: true, ID: $(".irfcsap").attr("id") });
		} /*else if (tipo == "estcomercial") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "validadeEmDias", Valor: $(".irfcsap").val(), Ativo: true, ID: $(".irfcsap").attr("id") });
		}*/ else if (tipo == "prorrogacao") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "diasmaximo", Valor: $(".diasmaximo").val(), Ativo: true, ID: $(".diasmaximo").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "jurospadraobrl", Valor: $(".jurospadraobrl").val(), Ativo: true, ID: $(".jurospadraobrl").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "jurospadraousd", Valor: $(".jurospadraousd").val(), Ativo: true, ID: $(".jurospadraousd").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "jurosmin", Valor: $(".jurosmin").val(), Ativo: true, ID: $(".jurosmin").attr("id") });
		} else if (tipo == "exposicao") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "tiposordem", Valor: $(".tiposordem").val(), Ativo: true, ID: $(".tiposordem").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "tipostitulo", Valor: $(".tipostitulo").val(), Ativo: true, ID: $(".tipostitulo").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "pcmaxestouro", Valor: $(".pcmaxestouro").val(), Ativo: true, ID: $(".pcmaxestouro").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "vlmaxestouro", Valor: $(".vlmaxestouro").val(), Ativo: true, ID: $(".vlmaxestouro").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "diasvigencia", Valor: $(".diasvigencia").val(), Ativo: true, ID: $(".diasvigencia").attr("id") });
		} else if (tipo == "vendasesp") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "tiposcontrato", Valor: $(".tiposcontrato").val(), Ativo: true, ID: $(".tiposcontrato").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "tiposfa", Valor: $(".tiposfa").val(), Ativo: true, ID: $(".tiposfa").attr("id") });
		} else if (tipo == "ordem") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "condicaovista", Valor: $(".condicaovista").val(), Ativo: true, ID: $(".condicaovista").attr("id") });
		} else if (tipo == "cliente") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "percentual", Valor: $(".cpercentual").val(), Ativo: true, ID: $(".cpercentual").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "valor", Valor: $(".cvalor").val(), Ativo: true, ID: $(".cvalor").attr("id") });
		} else if (tipo == "fluxo") {
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "percentual", Valor: $(".fpercentual").val(), Ativo: true, ID: $(".fpercentual").attr("id") });
			data.push({ Grupo: grupo, Tipo: tipo, Chave: "valor", Valor: $(".fvalor").val(), Ativo: true, ID: $(".fvalor").attr("id") });
		} else {
			// Casos de apenas um valor
			data.push({
				Grupo: grupo,
				Tipo: tipo,
				Valor: valor,
				Ativo: true,
				ID: id
			});
		}

		this.parameterService.insertParameter(this.token, data).subscribe(result => {
			if (result.Success) {
				this.getParameters(tipo);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

}



// WEBPACK FOOTER //
// ./src/app/parameters/component/parameters/parameters.component.ts